<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <!-- No pb-5: the company form (ContactDetail.vue) uses a plain card, and
               that padding left an empty band under the last field. -->
          <card>
            <template slot="header">
                <h4 class="card-title cd-breadcrumb-title">
                  <i class="icon-svg icon-user"></i>
                  <router-link to="/admin/users" class="cd-breadcrumb-title__link">{{$t('Usuarios')}}</router-link>
                  <span class="cd-breadcrumb-title__sep">/</span>
                  <span class="cd-breadcrumb-title__current">{{type}} {{title}}</span>
                </h4>
            </template>
            <!-- Same fields, in the same order, as the user modal of the company
                 form: name, email, the password pair, position + role and the
                 active switch. -->
            <form class="cd-user-form">
                <div class="row">
                    <div class="col-md-12">
                        <base-input type="text" :label="$t('Nombre')" :placeholder="$t('Nombre')" autocomplete="false"  v-model="name">
                            <template v-slot:textError v-if="$v.name.$error">
                                <span v-if="!$v.name.required" >{{$t('Campo_requerido')}}</span>
                            </template>
                        </base-input>
                        <!-- Company the user belongs to. Information only: it is set by
                             the company form, through which the user is created. -->
                        <p class="cd-user-company" v-if="company">
                            <i class="icon-svg icon-user"></i>{{$t('Company')}}: <strong>{{company}}</strong>
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <base-input type="text" :label="$t('Email')" :placeholder="$t('Email')" autocomplete="false"  v-model="email">
                            <template v-slot:textError  v-if="$v.email.$error">
                                <div  v-if="!$v.email.required" >{{$t('Campo_requerido')}}</div>
                                <div  v-if="!$v.email.email" >{{$t('validation_email')}}</div>
                            </template>
                        </base-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <base-input type="password" autocomplete="new-password" :label="$t('Password')" :placeholder="$t('Password')"  v-model="password">
                            <template v-slot:textError v-if="$v.password.$error">
                                <span v-if="!$v.password.required" >{{$t('Campo_requerido')}}</span>
                                <span v-else-if="!$v.password.minLength" >{{$t('password_length')}}</span>
                            </template>
                        </base-input>
                    </div>
                    <div class="col-md-6">
                        <base-input type="password" autocomplete="new-password" :label="$t('Repeat Password')" :placeholder="$t('Repeat Password')"  v-model="repassword">
                            <template v-slot:textError v-if="$v.repassword.$error">
                                <span v-if="!$v.repassword.sameAsPassword" >{{$t('password_not_equals')}}</span>
                            </template>
                        </base-input>
                    </div>
                </div>
                <!-- Editing: both boxes empty means "leave the password as it is". -->
                <p class="cd-user-password-hint" v-if="id">{{$t('password_keep_hint')}}</p>
                <div class="row">
                    <!-- Position first and role second, the order of the modal. It is
                         not required here: an administrator has no company, and
                         therefore no position to fill in. -->
                    <div class="col-md-6">
                        <base-input type="text" :label="$t('user_position')" :placeholder="$t('user_position')" autocomplete="false" v-model="position"/>
                    </div>
                    <div class="col-md-6">
                        <base-select :label="$t('Rol')" :placeholder="$t('Rol')" v-model="rol_id" :items="roles">
                            <template v-slot:textError v-if="$v.rol_id.$error">
                                <span v-if="!$v.rol_id.required" >{{$t('Campo_requerido')}}</span>
                            </template>
                        </base-select>
                    </div>
                </div>
                <base-checkbox id="chk_active" class="cd-user-active" v-model="active">{{$t('Activado')}}</base-checkbox>
                <div class="d-flex justify-content-start mt-2">
                    <button type="button" class="btn cd-btn-save" @click="submit">
                        {{$t("Guardar")}}
                    </button>
                </div>
                <div v-if="error" style="margin-top: 20px;">
                    <span class="invalid-feedback d-inline">{{ $t("error") }}</span>
                    <ul class="text-sm error-list" v-html="server_error"></ul>
                </div>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import { apiCallSingle } from '../../mixins'
    import { required, email, minLength, sameAs} from 'vuelidate/lib/validators';
import BaseSelect from '../../components/Inputs/BaseSelect.vue';
    export default {
        mixins: [apiCallSingle],
        components: {
                BaseSelect
        
        },
        props : {
            id: String
        },
        data () {
            return {
                endpoint: "user",
                section : "admin/users",
                title : this.$t('Usuario'),
                name    : null,
                email   : null,
                // Both password boxes start empty, as in the user modal of the company
                // form: filled in they change the password, left alone they keep it.
                // The field used to be prefilled with a fake value just to show the
                // dots, which made "clear it to keep the current one" impossible.
                password: null,
                repassword: null,
                active  : true,
                rol_id  : null,
                // Position within the company (lives in user_client, not in users).
                position: null,
                // Name of the company, shown as information only.
                company : null,
                roles   : []
            }
        },
        validations(){
            return {
                name : {
                    required
                },
                email : {
                    required,
                    email
                },
                // A new user needs a password; an existing one only when it is being
                // changed, and then it has to be eight characters long and be repeated
                // exactly. An empty field passes minLength, so the rule can stand for
                // both cases.
                password : this.id
                    ? { minLength: minLength (8) }
                    : { required, minLength: minLength (8) },
                repassword : {
                    sameAsPassword: sameAs ('password')
                },
                rol_id : {
                    required
                }
            }
        },
        created(){
            this.loadRoles();
        },
        methods : {
            OnDeleteUser ()
            {
              let self = this;
              if(self.is_primary){
                self.$dialog.alert({
                  title: self.$t("primary_contact"),
                  body: self.$t("primary_contact_delete_message"),
                }, { customClass: 'cd-dialog cd-dialog--danger' })
              }else{
                self.$dialog.confirm({
                  title: self.$t("EliminarContacto"),
                  body: self.$t("EliminarContactoText"),
                  okText: self.$t("Eliminar"),
                  cancelText: self.$t("Cancelar"),
                },
                { customClass: 'cd-dialog cd-dialog--danger' })
                    .then(function() {
                      self.$axios.delete("/user/"+self.id)
                          .then(() =>{
                            self.$router.push('/admin/users');
                          })
                          .catch(() => {
                            self.$dialog.alert({
                              title: self.$t("EliminarUsers"),
                              body: self.$t("server_error")
                            }, { customClass: 'cd-dialog cd-dialog--danger' })
                          })

                    })
              }
            },

            deleteUser(id){
              this.$store.dispatch ('isLoadingOn');
              this.$axios.post (`/delete_user`, {"user_id" : id})
                  .then (() => {
                    this.$store.dispatch ('isLoadingOff');
                  })
                  .catch (() => {
                    this.$store.dispatch ('isLoadingOff');
                  });

            },
            loadPasswordMd5(data){
              return data;
              /*this.$axios ("/user?where-email=" + data)
                  .then ((response) => {
                    console.log("----------------");
                    console.log(response.data[0].password);
                  })*/
            },
            loadData(){
                this.name     = this.data.name;
                this.email    = this.data.email;
                this.rol_id   = this.data.rol_id;
                this.active   = this.data.active == 1;
                // client_user is the row of user_client and carries the position;
                // client is the company itself. An administrator has neither.
                this.position = this.data.client_user ? this.data.client_user.position : null;
                this.company  = this.data.client
                    ? (this.data.client.lastname
                        ? `${this.data.client.name} ${this.data.client.lastname}`
                        : this.data.client.name)
                    : null;
            },
            getProperties(){
                const properties = {
                    name    : this.name,
                    email   : this.email,
                    rol_id  : this.rol_id,
                    position: this.position,
                    active  : this.active ? 1 : 0
                };
                // Only when it was typed: without it the API leaves the stored
                // password untouched.
                if (this.password) properties.password = this.password;
                return properties;
            },
            loadRoles(){
                this.$axios("/roles")
                    .then((response) => {
                        this.roles = response.data;
                    })
            }
        }
  }
</script>
<style>
/* base-input renders as a plain .form-group and its input is a direct child, while
   base-select renders as a .row.form-group whose field sits inside a .col-12.px-3.
   That column brings 15px of side padding and 6px above and below, so side by side in
   the two halves of a row the combobox ended up 6px lower and narrower than the input
   next to it. Its gutters are flattened here, inside this form only.

   Only .px-3 is targeted, which in base-select is the field (and the error line) but
   never the label: the label sits in a plain .col-12 whose 6px match the ones of
   base-input, and clearing those too would push the select 6px the other way.
   !important is not decorative either -- the padding of Bootstrap's .px-3 carries it.

   Measured on the real components: Cargo and Rol go from a 6px vertical offset to
   top, height and width matching exactly. */
.cd-user-form .form-group.row {
  margin-left: 0;
  margin-right: 0;
}
.cd-user-form .form-group.row > .px-3 {
  padding: 0 !important;
}
/* Note under the password pair, same wording and weight as the one in the modal. */
.cd-user-password-hint {
  margin: -0.25rem 0 0.5rem;
  color: var(--cd-text-muted);
  font-size: 12px;
}
.cd-user-active {
  margin: 0.25rem 0 0;
}
/* Company under the name: a read-only detail, so it is quieter than the fields and
   sits tight under the input it belongs to. */
.cd-user-company {
  margin: -0.35rem 0 0.75rem;
  color: var(--cd-text-muted);
  font-size: 13px;
}
.cd-user-company i {
  margin-right: 0.4rem;
}
.cd-user-company strong {
  color: var(--cd-text-body);
}
</style>